import React from 'react'
import {Box,Typography,AppBar,Toolbar,IconButton,Paper} from "@mui/material"
import { AppRegistration, FindInPage, Fingerprint, FingerprintRounded, MedicalServices, School, VpnKey } from '@mui/icons-material'

export default function AsthaTimeline({index,title,text}) {

  return (
    <Box sx={{display:"flex",flexDirection:{xs:"column",md:"row"},width:{xs:"90vw",md:"40vw"},alignItems:{xs:"flex-start",md:"center"},justifyContent:'space-around',margin:"3vh 5vw"}}>
        <Box bgcolor="#f4f4f4" sx={{padding:"1rem",borderRadius:"50%",width:"4vh",height:"4vh",display:"flex",flexDirection:{xs:"column",md:"row"},alignItems:"center",justifyContent:"center",margin:"0 1rem"}}><Typography variant="h3" color="primary.900">{index}</Typography></Box>
        <Box sx={{display:"flex"}}>
            <Box>
            <Typography variant="h4" color="primary">{title}</Typography>
            <Typography>{text}</Typography>
            
            </Box>
            {index==1 && <FingerprintRounded sx={{width:{xs:"15vw",md:"3vw"},fontSize:"64px"}} color="primary"/>}
            {index==2 && <VpnKey sx={{width:{xs:"15vw",md:"3vw"},fontSize:"64px"}} color="primary"/>}
            {index==3 && <FindInPage sx={{width:{xs:"15vw",md:"3vw"},fontSize:"64px"}} color="primary"/>}
            {index==4 && <MedicalServices sx={{width:{xs:"15vw",md:"3vw"},fontSize:"64px"}} color="primary"/>}
            {index==5 && <School sx={{width:{xs:"15vw",md:"3vw"},fontSize:"64px"}} color="primary"/>}
        </Box>
    </Box>
  )
}
